import { BaseApiService } from "./BaseApiService";
import { PREFIX } from "utils/Const";
import {
  IApiResponse,
  IDeliveryProgress,
  IGetByIdRequest,
  IGetDeliveryProgressRequest,
  IGetLoadingOrderPalletsRequest,
  IGetLoadingOrderProductRequest,
  IGetRelatedDocumentRequest,
  IImportLoadingOrderDocument,
  ILoadingOrder,
  ILoadingOrderPallet,
  ILoadingOrderProduct,
  IPaginateApiResponse,
  IPaginationRequest,
  IRelatedDocument,
  IUpdateLoadingOrderDocumentRequest,
} from "model";

const prefix = PREFIX.receive;

const GET_ALL_LOADING_ORDER_URL = `${prefix}/loading-order/get-all`;
const URL_GET_LO_DOCUMENT_BY_ID = `${prefix}/loading-order`;
const URL_UPDATE_LO_DOCUMENT = `${prefix}/loading-order/update`;
const GET_LOADING_ORDER_PRODUCT_URL = `${prefix}/loading-order/products`;
const GET_DELIVERY_PROGRESS_URL = `${prefix}/loading-order/delivery-progress`;
const GET_LOADING_ORDER_PALLET_URL = `${prefix}/loading-order/pallets`;
const GET_RELATED_DOCUMENTS_URL = `${prefix}/loading-order/related-documents`;
const IMPORT_LOADING_ORDER_DOCUMENT = `${prefix}/import-loading-order-document`;

class LoadingOrderApiService extends BaseApiService {
  public getAllLoadingOrder = (request: IPaginationRequest) =>
    this.get<IPaginateApiResponse<ILoadingOrder[]>>(GET_ALL_LOADING_ORDER_URL, {
      params: request,
    });
  public getLOById = (request: IGetByIdRequest) =>
    this.get<IApiResponse<ILoadingOrder>>(
      `${URL_GET_LO_DOCUMENT_BY_ID}/${request.id}`
    );
  public getAllLoadingOrderProducts = (
    request: IGetLoadingOrderProductRequest
  ) =>
    this.get<IPaginateApiResponse<ILoadingOrderProduct[]>>(
      GET_LOADING_ORDER_PRODUCT_URL,
      {
        params: request,
      }
    );
  public getDeliveryProgress = (request: IGetDeliveryProgressRequest) =>
    this.get<IPaginateApiResponse<IDeliveryProgress[]>>(
      GET_DELIVERY_PROGRESS_URL,
      {
        params: request,
      }
    );
  public getAllLoadingOrderPallets = (
    request: IGetLoadingOrderPalletsRequest
  ) =>
    this.get<IPaginateApiResponse<ILoadingOrderPallet[]>>(
      GET_LOADING_ORDER_PALLET_URL,
      {
        params: request,
      }
    );
  public getRelatedDocuments = (request: IGetRelatedDocumentRequest) =>
    this.get<IPaginateApiResponse<IRelatedDocument[]>>(
      GET_RELATED_DOCUMENTS_URL,
      {
        params: request,
      }
    );
  public updateLoadingOrderDocument = (
    request: IUpdateLoadingOrderDocumentRequest
  ) =>
    this.put<IUpdateLoadingOrderDocumentRequest, IApiResponse<ILoadingOrder>>(
      URL_UPDATE_LO_DOCUMENT,
      request
    );
  public importLoadingOrderDocument = (request: IImportLoadingOrderDocument) =>
    this.postForm<any>(IMPORT_LOADING_ORDER_DOCUMENT, request);
}

export default new LoadingOrderApiService(true);
